exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Noto+Sans+TC|Quicksand);", ""]);

// module
exports.push([module.id, ".full[data-v-31c782b4]{width:100%;height:100%}.yo-app[data-v-31c782b4]{font-family:Quicksand,Noto Sans TC,Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#2c3e50}.fade-enter-active[data-v-31c782b4],.fade-leave-active[data-v-31c782b4]{-webkit-transition:opacity .5s;transition:opacity .5s}.fade-enter[data-v-31c782b4],.fade-leave-to[data-v-31c782b4]{opacity:0}", ""]);

// exports
